import React from 'react';
import { BadgeCheckIcon } from 'lucide-react';
import { ButtonLink } from '../../components/ui/Button';
export function ClaimSuccess() {
  return <div className="flex flex-1 flex-col items-center justify-center bg-white px-6 py-24 text-center" data-id="element-753" data-mp="dpo570thjogq">
      <BadgeCheckIcon className="h-14 w-14 text-emerald-500" data-id="element-754" data-mp="8uqkgwmufqo0" />
      <h1 className="mt-5 text-[19px] font-bold text-ink-900" data-id="element-755" data-mp="3wp1ebpf3rcj">Claim Created Successfully</h1>
      <p className="mt-2 max-w-md text-[13px] text-ink-500" data-id="element-756" data-mp="3v54bf476ohb0">
        Your claim is currently under review. We&apos;ll contact you with the next steps once it&apos;s
        approved
      </p>
      <ButtonLink to="/claims" variant="secondary" className="mt-6" data-id="element-757" data-mp="3m2ldmyi98uvm">
        Continue to Claims List
      </ButtonLink>
    </div>;
}